import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { url } from "./url.service";
import axiosAuth from "./axios.service";

const baseUrl = `${url}/admin/attributes`;

// GET ALL ATTRIBUTES
export const getAllAttributes = async (queryParams?: any) => {
  return await axiosAuth.get(`${baseUrl}/`, {
    params: {
      ...queryParams
    }
  });
};

export const useGetAllAttributes = (enabled: boolean, queryParams?: any) => {
  return useQuery({
    queryKey: ["attributes", queryParams],
    queryFn: () => getAllAttributes(queryParams).then((res) => res?.data?.data),
    enabled: enabled,
  });
};





const baseUrl2 = `${url}/common/attributes`;

// GET ALL ATTRIBUTES
export const getAllAttributesCommon = async (queryParams?: any) => {
  return await axiosAuth.get(`${baseUrl2}/`, {
    params: {
      ...queryParams
    }
  });
};

export const useGetAllAttributesCommon = (enabled: boolean, queryParams?: any) => {
  return useQuery({
    queryKey: ["attributes-common", queryParams],
    queryFn: () => getAllAttributesCommon(queryParams).then((res) => res?.data?.data),
    enabled: enabled,
  });
};







// CREATE NEW ATTRIBUTE
export const addAttribute = async (data: any) => {
  return await axiosAuth.post(`${baseUrl}/`, data);
};

export const useAddAttribute = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addAttribute,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["attributes"] });
    },
  });
};

// DELETE A ATTRIBUTE
export const deleteAttribute = async (data: {
  type: string;
  attributeId: string;
}) => {
  return await axiosAuth.delete(`${baseUrl}/`, { data });
};

export const useDeleteAttribute = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteAttribute,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["attributes"] });
    },
  });
};

// UPDATE ATTRIBUTE STATUS
export const updateAttributeStatus = async (data: {
  type: string;
  attributeId: string;
  status: boolean;
}) => {
  return await axiosAuth.patch(`${baseUrl}/`, data);
};

export const useUpdateAttributeStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateAttributeStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["attributes"] });
    },
  });
};
